import React, { useState, useEffect } from "react";
import { CreateNewCarePlan } from "../../../../utils/globalState";
import ChooseFuForm from "./ChooseFuForm";
import CpFormBuilder from "../CpFormBuilder";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";

import { handleGetFuForms } from "../../../../services/CarePlan";
import { decodeToken } from "react-jwt";
import { useModal } from "react-hooks-use-modal";

const SelectFupForm = (props) => {
  const { privileges } = props;

  const stateObj = CreateNewCarePlan((state) => state.careplanController);
  const pharmacyId = localStorage.getItem("pharmacy");
  const token = localStorage.getItem("Token");
  const myDecodedToken = decodeToken(token) || {};
  const userID = myDecodedToken.userId;
  const [addFormflag, setAddFormflag] = useState(false);
  const [msg, setMsg] = useState("");
  const [forms, setForms] = useState([]);
  const [form, setForm] = useState({});
  const [userInput, setUserInput] = useState({
    title: "",
    type: "",
  });
  const [Modal, openModal, close] = useModal("root", {
    preventScroll: true,
    closeOnOverlayClick: false,
  });
  const handleSelectForm = (form) => {
    console.log(form);
    CreateNewCarePlan.setState({
      careplanController: {
        ...stateObj,
        completeflag: {
          ...stateObj.completeflag,
          followup_form: true,
        },
        info: {
          ...stateObj.info,
          followup_form: form,
        },
      },
    });
  };

  useEffect(() => {
    handleGetFuForms(pharmacyId)
      .then((res) => {
        console.log(res);
        setForms(
          res.data.map((form) => {
            form.isSent = form.isSent === 1 ? true : false;
            form.isHidden = form.isHidden === 1 ? true : false;
            form.json = JSON.parse(form.formText);
            return form;
          })
        );
      })
      .catch((err) => {
        console.log(err);
        setForms([]);
      });
  }, [pharmacyId]);

  const handleShowCreator = () => {
    setAddFormflag(!addFormflag);
  };

  const handleCreate = () => {
    console.log(userInput);
    setMsg("");
    if (userInput.title !== "") {
      if (forms.some((form) => form.json.title === userInput.title)) {
        setMsg("Form with this title already exists");
        return;
      }
      setForm({
        isSent: false,
        isInitForm: false,
        json: {
          title: userInput.title,
          pages: [
            {
              name: "page1",
              elements: [
                {
                  type: "boolean",
                  name: "followup-schedule",
                  title: "Would you like to update the follow up schedule?",
                },
              ],
            },
          ],
          calculatedValues: [
            {
              name: "firstname-for-complete-page",
              expression: "iif({first-name} notempty, {first-name}, patient)",
            },
          ],
          showQuestionNumbers: "off",
          questionErrorLocation: "bottom",
          completeText: "Complete",
          questionsOnPageMode: "singlePage",
          widthMode: "static",
          width: "1024",
        },
      });
      setAddFormflag(true);
      close();
      setUserInput({ title: "" });
      setMsg("");
    } else {
      setMsg("Please fill in all the fields");
    }
  };

  const handleTitleChange = (event) => {
    setUserInput({ ...userInput, [event.target.name]: event.target.value });
  };

  const handleSuccess = (success) => {
    if (success) {
      setMsg("Form added successfully");
      setAddFormflag(false);
    } else {
    }
  };
  return (
    <div className="row">
      {addFormflag ? (
        <>
          <div className="col-12 mb-3">
            <CpFormBuilder
              form={form}
              userID={userID}
              creatorType="pharmacy"
              setShowCreator={handleShowCreator}
              setForm={handleSelectForm}
              handleSuccess={handleSuccess}
            />
          </div>
        </>
      ) : (
        <>
          <div className="col-12 ">
            <ChooseFuForm setForm={handleSelectForm} />
          </div>
          {["admin", "careplan forms"].some((priv) =>
            privileges.includes(priv)
          ) && (
            <>
              <div className="col-12 mt-3 mb-3 ">
                <Divider> OR </Divider>
              </div>
              <div className="col-12 d-flex justify-content-center  ">
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => openModal()}>
                  Add New Form
                </Button>
              </div>
            </>
          )}

          <div className="col-12">
            <div className="row">
              <div className="col-12 d-flex justify-content-center pt-3 ">
                <p className="text-center text-success">{msg}</p>
              </div>
            </div>
          </div>
        </>
      )}
      <Modal>
        <div className="card  mb-3" style={{ maxWidth: "35rem" }}>
          {msg !== "" && <p className="text-danger">{msg}</p>}
          <div className="card-header bg-transparent fw-bold text-center">
            Create New Form
          </div>
          <div className="card-body">
            {/* <h5 className="card-title">Success card title</h5> */}
            <form>
              <div className="mb-3">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Form Title
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  onChange={handleTitleChange}
                  value={userInput.title}
                  name="title"
                />
              </div>
            </form>
          </div>
          <div className="card-footer bg-transparent text-center">
            <button
              type="button"
              className="btn btn-danger mx-2 mx-2"
              data-bs-dismiss="modal"
              onClick={() => close()}>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary mx-2 mx-2"
              onClick={handleCreate}>
              Create
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SelectFupForm;
